// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/shielded_pool/v1/shielded_pool.proto (package penumbra.core.component.shielded_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { Address, AddressView, PayloadKey } from "../../../keys/v1/keys_pb.js";
import { AssetId, BalanceCommitment, Metadata, Value, ValueView } from "../../../asset/v1/asset_pb.js";
import { StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
import { SpendAuthSignature, SpendVerificationKey } from "../../../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { Nullifier } from "../../sct/v1/sct_pb.js";
import { Clue } from "../../../../crypto/decaf377_fmd/v1/decaf377_fmd_pb.js";
import { TransactionId } from "../../../txhash/v1/txhash_pb.js";

/**
 * Configuration data for the shielded pool component.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters
 */
export const ShieldedPoolParameters = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters",
  () => [
    { no: 1, name: "fixed_fmd_params", kind: "message", T: FmdParameters },
    { no: 2, name: "fmd_meta_params", kind: "message", T: FmdMetaParameters },
  ],
);

/**
 * Genesis data for the shielded pool component.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.GenesisContent",
  () => [
    { no: 1, name: "shielded_pool_params", kind: "message", T: ShieldedPoolParameters },
    { no: 3, name: "allocations", kind: "message", T: GenesisContent_Allocation, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.GenesisContent.Allocation
 */
export const GenesisContent_Allocation = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.GenesisContent.Allocation",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address", kind: "message", T: Address },
  ],
  {localName: "GenesisContent_Allocation"},
);

/**
 * The parameters which control how the FMD parameters evolve over time.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParameters
 */
export const FmdMetaParameters = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdMetaParameters",
  () => [
    { no: 1, name: "fmd_grace_period_blocks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "fixed_precision_bits", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "algorithm" },
    { no: 3, name: "sliding_window", kind: "message", T: FmdMetaParameters_AlgorithmSlidingWindow, oneof: "algorithm" },
  ],
);

/**
 * A sliding window algorithm for updating the parameters.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParameters.AlgorithmSlidingWindow
 */
export const FmdMetaParameters_AlgorithmSlidingWindow = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdMetaParameters.AlgorithmSlidingWindow",
  () => [
    { no: 1, name: "window_update_periods", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "targeted_detections_per_window", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "FmdMetaParameters_AlgorithmSlidingWindow"},
);

/**
 * Used to potentially store state for the FMD Meta Parameters algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState
 */
export const FmdMetaParametersAlgorithmState = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState",
  () => [
    { no: 1, name: "fixed", kind: "message", T: FmdMetaParametersAlgorithmState_FixedState, oneof: "state" },
    { no: 2, name: "sliding_window", kind: "message", T: FmdMetaParametersAlgorithmState_SlidingWindowState, oneof: "state" },
  ],
);

/**
 * The state used for the fixed algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.FixedState
 */
export const FmdMetaParametersAlgorithmState_FixedState = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.FixedState",
  [],
  {localName: "FmdMetaParametersAlgorithmState_FixedState"},
);

/**
 * The state used for the sliding window algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.SlidingWindowState
 */
export const FmdMetaParametersAlgorithmState_SlidingWindowState = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.SlidingWindowState",
  () => [
    { no: 1, name: "approximate_clue_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "FmdMetaParametersAlgorithmState_SlidingWindowState"},
);

/**
 * Parameters for Fuzzy Message Detection
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdParameters
 */
export const FmdParameters = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.FmdParameters",
  () => [
    { no: 1, name: "precision_bits", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "as_of_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.Note
 */
export const Note = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.Note",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "address", kind: "message", T: Address },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.NoteView
 */
export const NoteView = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.NoteView",
  () => [
    { no: 1, name: "value", kind: "message", T: ValueView },
    { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "address", kind: "message", T: AddressView },
  ],
);

/**
 * An encrypted note.
 * 176 = 80(address) + 16(amount) + 32(asset ID) + 32(rseed) + 16(MAC) bytes.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.NoteCiphertext
 */
export const NoteCiphertext = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.NoteCiphertext",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * The body of an output description, including only the minimal
 * data required to scan and process the output.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.NotePayload
 */
export const NotePayload = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.NotePayload",
  () => [
    { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "ephemeral_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "encrypted_note", kind: "message", T: NoteCiphertext },
  ],
);

/**
 * A Penumbra ZK output proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKOutputProof
 */
export const ZKOutputProof = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.ZKOutputProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A Penumbra ZK spend proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKSpendProof
 */
export const ZKSpendProof = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.ZKSpendProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A Penumbra ZK nullifier derivation proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKNullifierDerivationProof
 */
export const ZKNullifierDerivationProof = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.ZKNullifierDerivationProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Spends a shielded note.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.Spend
 */
export const Spend = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.Spend",
  () => [
    { no: 1, name: "body", kind: "message", T: SpendBody },
    { no: 2, name: "auth_sig", kind: "message", T: SpendAuthSignature },
    { no: 3, name: "proof", kind: "message", T: ZKSpendProof },
  ],
);

/**
 * ABCI Event recording a spend.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventSpend
 */
export const EventSpend = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.EventSpend",
  () => [
    { no: 1, name: "nullifier", kind: "message", T: Nullifier },
  ],
);

/**
 * ABCI Event recording an output.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventOutput
 */
export const EventOutput = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.EventOutput",
  () => [
    { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
  ],
);

/**
 * ABCI Event recording a clue.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventBroadcastClue
 */
export const EventBroadcastClue = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.EventBroadcastClue",
  () => [
    { no: 1, name: "clue", kind: "message", T: Clue },
    { no: 2, name: "tx", kind: "message", T: TransactionId },
  ],
);

/**
 * The body of a spend description, containing only the effecting data
 * describing changes to the ledger, and not the authorizing data that allows
 * those changes to be performed.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendBody
 */
export const SpendBody = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.SpendBody",
  () => [
    { no: 1, name: "balance_commitment", kind: "message", T: BalanceCommitment },
    { no: 6, name: "nullifier", kind: "message", T: Nullifier },
    { no: 4, name: "rk", kind: "message", T: SpendVerificationKey },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView
 */
export const SpendView = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.SpendView",
  () => [
    { no: 1, name: "visible", kind: "message", T: SpendView_Visible, oneof: "spend_view" },
    { no: 2, name: "opaque", kind: "message", T: SpendView_Opaque, oneof: "spend_view" },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView.Visible
 */
export const SpendView_Visible = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.SpendView.Visible",
  () => [
    { no: 1, name: "spend", kind: "message", T: Spend },
    { no: 2, name: "note", kind: "message", T: NoteView },
  ],
  {localName: "SpendView_Visible"},
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView.Opaque
 */
export const SpendView_Opaque = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.SpendView.Opaque",
  () => [
    { no: 1, name: "spend", kind: "message", T: Spend },
  ],
  {localName: "SpendView_Opaque"},
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendPlan
 */
export const SpendPlan = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.SpendPlan",
  () => [
    { no: 1, name: "note", kind: "message", T: Note },
    { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "randomizer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "value_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Creates a new shielded note.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.Output
 */
export const Output = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.Output",
  () => [
    { no: 1, name: "body", kind: "message", T: OutputBody },
    { no: 2, name: "proof", kind: "message", T: ZKOutputProof },
  ],
);

/**
 * The body of an output description, containing only the effecting data
 * describing changes to the ledger, and not the authorizing data that allows
 * those changes to be performed.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputBody
 */
export const OutputBody = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.OutputBody",
  () => [
    { no: 1, name: "note_payload", kind: "message", T: NotePayload },
    { no: 2, name: "balance_commitment", kind: "message", T: BalanceCommitment },
    { no: 3, name: "wrapped_memo_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "ovk_wrapped_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView
 */
export const OutputView = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.OutputView",
  () => [
    { no: 1, name: "visible", kind: "message", T: OutputView_Visible, oneof: "output_view" },
    { no: 2, name: "opaque", kind: "message", T: OutputView_Opaque, oneof: "output_view" },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView.Visible
 */
export const OutputView_Visible = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.OutputView.Visible",
  () => [
    { no: 1, name: "output", kind: "message", T: Output },
    { no: 2, name: "note", kind: "message", T: NoteView },
    { no: 3, name: "payload_key", kind: "message", T: PayloadKey },
  ],
  {localName: "OutputView_Visible"},
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView.Opaque
 */
export const OutputView_Opaque = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.OutputView.Opaque",
  () => [
    { no: 1, name: "output", kind: "message", T: Output },
  ],
  {localName: "OutputView_Opaque"},
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputPlan
 */
export const OutputPlan = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.OutputPlan",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "dest_address", kind: "message", T: Address },
    { no: 3, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "value_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Requests information on an asset by asset id
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdRequest
 */
export const AssetMetadataByIdRequest = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdRequest",
  () => [
    { no: 2, name: "asset_id", kind: "message", T: AssetId },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdResponse
 */
export const AssetMetadataByIdResponse = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdResponse",
  () => [
    { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
  ],
);

/**
 * Requests information on an asset by multiple asset ids
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsRequest
 */
export const AssetMetadataByIdsRequest = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsRequest",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsResponse
 */
export const AssetMetadataByIdsResponse = proto3.makeMessageType(
  "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsResponse",
  () => [
    { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
  ],
);

